import { CiReport } from '@cibo/core'
import { Loading } from '@cibo/profile'
import { Container, Paper, Stack, Typography } from '@mui/material'
import { useInventory } from 'features/Inventories'
import { HistoricalCarbonIntensity } from 'features/Inventories/components/HistoricalCarbonIntensity'
import { ascend, pipe, prop, propEq, reject, sort } from 'ramda'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WaitingPage } from './WaitingPage'

type BaselineInfoProps = {
  inventoryId: string
}

export const BaselineInfo = ({ inventoryId }: BaselineInfoProps) => {
  const { data: inventory, isLoading } = useInventory(inventoryId)

  const { t } = useTranslation('impact/SelectBasePeriod')

  const [commodity] = useState('Corn')

  if (isLoading) return <Loading large />

  const rows = pipe<CiReport, CiReport, CiReport>(
    reject(propEq('year', 2024)),
    sort(ascend(prop('year')))
  )(inventory?.item.data.ciJobResult?.ciReport || [])

  if (inventory?.item.data.ciJobResult?.status === 'complete' && !!rows) {
    return (
      <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Paper variant="outlined" sx={{ borderRadius: '12px' }}>
          <Stack padding={3} spacing={1}>
            <Stack spacing={0.5}>
              <Typography variant="h6">{t('historicalCarbonIntensity')}</Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {t('historicalSubtitle')}
              </Typography>
            </Stack>

            <HistoricalCarbonIntensity reportData={rows} commodity={commodity} height={200} />
          </Stack>
        </Paper>
      </Container>
    )
  }

  return <WaitingPage />
}
